export default "__VITE_ASSET__083521fc__"